



































































































import { Vue, Prop, Component } from "vue-property-decorator"
import { WebinarInfo } from "../../models/WebinarInfo"
import VideoPlayer from "../shared/PictureInPictureVideo.vue"
var SocialSharing = require("vue-social-sharing")
Vue.use(SocialSharing)
import "../../assets/timeline.ts"
import "../../assets/timeline.scss"
import { AwEventStore } from "../../models/AwEventStore"
import { AwEventType } from "../../models/AwEventType"
import { EventBus } from "../../event-bus"
import VideoOnVideoInfo from "../../models/VideoOnVideoInfo"

@Component({
  components: {
    VideoPlayer
  }
})
export default class TimelineLayout extends Vue {
  @Prop() public webinarInfo!: VideoOnVideoInfo

  socialShareUrl = ""
  mounted() {
    this.socialShareUrl = this.$root.$data.socialShareUrl
    var key = this.$root.$data.identifierKey
    this.$root.$on("social_shares_open", function(network: any, url: string) {
      // var temp = url.split("/")
      // var momentid = temp[temp.length - 1]
      // var event: AwEventStore = {
      //   eventType: AwEventType.MomentShared,
      //   momentId: parseInt(momentid)
      // }
      // EventBus.$emit("registeranalytics", event, key)
    })
  }
}
